import { brandPagesSlice } from '../slices/brandPagesSlice';

export default brandPagesSlice.reducer;
